import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/MainPage.css';

const defaultConfig = {
	hero_title: 'SERVICIO DE MANTENCIÓN ESPECIALIZADA',
	hero_subtitle: 'Soluciones integrales para la continuidad operativa de tu industria',
	phone_primary: '+56 9 7389 1406',
	phone_secondary: '+56 9 3080 7076',
	email_primary: 'contacto@ker.cl'
};

export default function MainPage() {
	const [currentSlide, setCurrentSlide] = useState(0);
	const [menuActive, setMenuActive] = useState(false);
	const [formMessage, setFormMessage] = useState(null);
	const [formLoading, setFormLoading] = useState(false);
	const slideCount = 5;
	const slideInterval = useRef(null);

	useEffect(() => {
		if (window.elementSdk && window.elementSdk.init) {
			window.elementSdk.init({
				defaultConfig,
				onConfigChange: (cfg = {}) => {
					const title = cfg.hero_title || defaultConfig.hero_title;
					const subtitle = cfg.hero_subtitle || defaultConfig.hero_subtitle;
					const phone1 = cfg.phone_primary || defaultConfig.phone_primary;
					const phone2 = cfg.phone_secondary || defaultConfig.phone_secondary;
					const email = cfg.email_primary || defaultConfig.email_primary;
					const heroTitleEl = document.getElementById('heroTitle');
					if (heroTitleEl) heroTitleEl.innerHTML = title.replace('ESPECIALIZADA', '<span class="text-orange-primary">ESPECIALIZADA</span>');
					const heroSubEl = document.getElementById('heroSubtitle');
					if (heroSubEl) heroSubEl.textContent = subtitle;
					const phoneP = document.getElementById('phonePrimary'); if (phoneP) phoneP.textContent = phone1;
					const phoneS = document.getElementById('phoneSecondary'); if (phoneS) phoneS.textContent = phone2;
					const emailEl = document.getElementById('emailPrimary'); if (emailEl) emailEl.textContent = email;
				}
			});
		}
	}, []);

	useEffect(() => {
		slideInterval.current = setInterval(() => setCurrentSlide(s => (s + 1) % slideCount), 5000);
		return () => clearInterval(slideInterval.current);
	}, []);

	function changeSlide(n) {
		setCurrentSlide(s => {
			let next = s + n;
			if (next < 0) next = slideCount - 1;
			if (next >= slideCount) next = 0;
			return next;
		});
		clearInterval(slideInterval.current);
		slideInterval.current = setInterval(() => setCurrentSlide(s => (s + 1) % slideCount), 5000);
	}

	function goToSlide(i) {
		setCurrentSlide(i % slideCount);
		clearInterval(slideInterval.current);
		slideInterval.current = setInterval(() => setCurrentSlide(s => (s + 1) % slideCount), 5000);
	}

	async function handleSubmit(e) {
		e.preventDefault();
		const form = e.target;
		const name = (form.nombre?.value || form.name?.value || '').trim();
		const email = (form.correo?.value || form.email?.value || '').trim();
		const phone = (form.telefono?.value || form.phone?.value || '').trim();
		const company = (form.empresa?.value || form.company?.value || '').trim();
		const message = (form.mensaje?.value || form.message?.value || '').trim();

		if (message && message.length < 10) return setFormMessage({ text: 'El mensaje debe tener al menos 10 caracteres.', type: 'error' });
		if (!name || !company || !phone || !email || !message) return setFormMessage({ text: 'Completa todos los campos antes de enviar.', type: 'error' });

		setFormLoading(true); setFormMessage(null);
		try {
			const rawSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
			const siteKey = rawSiteKey.replace(/^['"]|['"]$/g, '').trim();
			if (!siteKey) { setFormLoading(false); setFormMessage({ text: 'Captcha no configurado. Contacta al administrador.', type: 'error' }); return; }
			const getRecaptchaToken = () => new Promise((resolve, reject) => {
				if (window.grecaptcha && window.grecaptcha.execute) { window.grecaptcha.ready(() => window.grecaptcha.execute(siteKey, { action: 'contact' }).then(resolve).catch(reject)); return; }
				const s = document.createElement('script'); s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`; s.async = true; s.defer = true;
				s.onload = () => { if (window.grecaptcha && window.grecaptcha.execute) { window.grecaptcha.ready(() => window.grecaptcha.execute(siteKey, { action: 'contact' }).then(resolve).catch(reject)); } else reject(new Error('reCAPTCHA no disponible')); };
				s.onerror = () => reject(new Error('No se pudo cargar reCAPTCHA')); document.head.appendChild(s);
			});

			const captchaToken = await getRecaptchaToken();
			const rawBase = process.env.REACT_APP_API_BASE_URL || '';
			const base = rawBase.replace(/\/$/, '');
			const url = `${base}/api/contact`;
			const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, email, phone, company, message, captchaToken }) });
			const data = await res.json().catch(() => ({}));
			setFormLoading(false);
			if (!res.ok) { setFormMessage({ text: data.error || data.message || 'Error al enviar el mensaje, intenta nuevamente.', type: 'error' }); return; }
			setFormMessage({ text: data.message || '¡Mensaje enviado! Nos contactaremos pronto.', type: 'success' });
			form.reset();
			setTimeout(() => setFormMessage(null), 5000);
		} catch (err) { setFormLoading(false); setFormMessage({ text: 'No se pudo conectar con el servidor. Intenta más tarde.', type: 'error' }); }
	}

	// Puedes agregar una imagen en cada slide usando la propiedad 'image'. Ejemplo: image: '/ruta/imagen.png'
	const slides = [
		{ badge: 'Servicio especializado', title: 'ESPECIALISTAS EN <span class="text-white drop-shadow-lg">CALDERAS</span>', subtitle: 'Más de 15 años de experiencia en mantención, reparación y operación de calderas industriales', cta: { href: '#servicios', label: 'Conocer más' }, animate: true, image: '/especialistas.png' },
		{ badge: 'Servicio preventivo', title: 'MANTENCIÓN DE <span class="text-orange-primary">EQUIPOS</span>', subtitle: 'Programas de mantención preventiva y predictiva para maximizar la vida útil de tus equipos', cta: { href: '#contacto', label: 'Solicitar evaluación' }, image: '/calderasrojas.png' },
		{ badge: 'Respuesta rápida', title: 'REPARACIÓN <span class="text-orange-primary">ESPECIALIZADA</span>', subtitle: 'Solución efectiva de fallas y reparaciones de emergencia con mínima interrupción operativa', cta: { href: '#contacto', label: 'Contactar ahora' }, image: '/soldadores.png' },
		{ badge: 'Mantenimiento profundo', title: 'LIMPIEZA Y <span class="text-white drop-shadow-lg">PASIVADO</span>', subtitle: 'Limpieza profunda de tubos y pasivado químico para optimizar la eficiencia de tus equipos', cta: { href: '#servicios', label: 'Ver detalles' }, image: '/limpieza.png' },
		{ badge: 'Cumplimiento normativo', title: 'CERTIFICACIÓN <span class="text-orange-primary">SEREMI</span>', subtitle: 'Preparación y apoyo integral para la certificación de calderas y operadores ante la autoridad', cta: { href: '#contacto', label: 'Solicitar asesoría' }, image: '/calderasola.png' }
	];

	return (
		<div className="page-wrapper">
			<nav className="fixed top-0 left-0 right-0 site-header shadow-sm z-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="flex justify-between items-center h-20">
						<div className="flex items-center gap-3">
							<div className="logo-container">
								<img src="/logo512.png" alt="KER Logo" className="logo-icon" />
							</div>
						</div>
						<div className="hidden md:flex items-center gap-8">
							<a href="#inicio" className="nav-link text-gray-corporate hover:text-orange-primary font-medium">Inicio</a>
							<a href="#servicios" className="nav-link text-gray-corporate hover:text-orange-primary font-medium">Servicios</a>
							<a href="#socio" className="nav-link text-gray-corporate hover:text-orange-primary font-medium">Socio Clave</a>
							<a href="#nosotros" className="nav-link text-gray-corporate hover:text-orange-primary font-medium">Quiénes Somos</a>
							<Link to="/login" className="px-4 py-2 rounded-lg border border-orange-primary text-orange-primary font-medium hover:bg-orange-primary/10">Ingresar</Link><a href="#contacto" className="btn-primary text-white px-6 py-2.5 rounded-lg font-semibold">Contacto</a>
						</div>
						<button id="menuBtn" className="md:hidden p-2 rounded-lg hover:bg-gray-100" onClick={() => setMenuActive(v => !v)}>
							<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
						</button>
					</div>
					<div id="mobileMenu" className={`${menuActive ? '' : 'hidden'} md:hidden pb-4`}> 
						<div className="flex flex-col gap-3">
							<a href="#inicio" className="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium">Inicio</a>
							<a href="#servicios" className="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium">Servicios</a>
							<a href="#socio" className="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium">Socio Clave</a>
							<a href="#nosotros" className="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium">Quiénes Somos</a>
							<Link to="/login" className="px-4 py-2 rounded-lg hover:bg-gray-100 font-medium">Ingresar</Link>
							<a href="#contacto" className="btn-primary text-white px-4 py-2 rounded-lg font-semibold text-center">Contacto</a>
						</div>
					</div>
				</div>
			</nav>

			<section id="inicio" className="pt-20">
				<div className="slider-container" style={{ height: '600px' }}>
					<div className="slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
						{slides.map((s, i) => (
							<div
								key={i}
								className="slider-slide"
								style={{
									position: 'relative',
									backgroundColor: '#535353',
									backgroundImage: s.image ? `url(${s.image})` : 'none',
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									backgroundRepeat: 'no-repeat',
								}}
							>
								{/* Capa gris semitransparente sobre la imagen */}
								<div style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%',
									background: 'rgba(83,83,83,0.78)',
									zIndex: 1
								}} />
								<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center" style={{ position: 'relative', zIndex: 2 }}>
									<div className={`text-white max-w-2xl ${s.animate ? 'animate-fade-in' : ''}`.trim()}>
										<div className={`${s.bg === 'slide-bg-2' ? 'inline-flex items-center gap-2 bg-white/20 border border-white/30 rounded-full px-4 py-2 mb-6' : 'inline-flex items-center gap-2 bg-orange-primary/20 border border-orange-primary/30 rounded-full px-4 py-2 mb-6'}`}>
											<span className={`${s.bg === 'slide-bg-2' ? 'w-2 h-2 bg-white rounded-full animate-pulse' : 'w-2 h-2 bg-orange-primary rounded-full animate-pulse'}`} />
											<span className="text-sm font-medium">{s.badge}</span>
										</div>
										<h2 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6" id="heroTitle" dangerouslySetInnerHTML={{ __html: s.title }} />
										<p id="heroSubtitle" className={`text-xl ${s.bg === 'slide-bg-2' ? 'text-white/90' : 'text-gray-300'} mb-8 leading-relaxed`}>{s.subtitle}</p>
										<a href={s.cta.href} className={`${s.bg === 'slide-bg-2' ? 'bg-white text-orange-primary px-8 py-4 rounded-lg font-bold text-lg inline-flex items-center gap-2 hover:bg-gray-100 transition-all' : 'btn-primary text-white px-8 py-4 rounded-lg font-bold text-lg inline-flex items-center gap-2'}`}>
											{s.cta.label}
											<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg>
										</a>
									</div>
								</div>
							</div>
						))}
					</div>

					<button className="slider-arrow slider-arrow-left" onClick={() => changeSlide(-1)} aria-label="Anterior">
						<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"/></svg>
					</button>
					<button className="slider-arrow slider-arrow-right" onClick={() => changeSlide(1)} aria-label="Siguiente">
						<svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/></svg>
					</button>

					<div className="slider-dots">
						{slides.map((_, i) => <div key={i} data-slide={i} className={`slider-dot ${currentSlide === i ? 'active' : ''}`} onClick={() => goToSlide(i)} />)}
					</div>
				</div>
			</section>

			<section id="servicios" className="py-16 bg-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center max-w-3xl mx-auto mb-16"><span className="text-orange-primary font-semibold uppercase tracking-wider text-sm">Lo que hacemos</span>
						<h2 className="font-heading font-bold text-4xl text-gray-corporate mt-4 mb-6">Nuestros <span className="text-orange-primary">Servicios</span></h2>
						<div className="section-divider mx-auto mb-6" />
						<p className="text-lg text-gray-600">Entregamos soluciones según la necesidad de cada cliente, asegurando la continuidad operativa de sus procesos.</p>
					</div>

					<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
						<div className="service-card bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
							<div className="h-2 bg-orange-primary" />
							<div className="p-8">
								<div className="service-icon-container icon-container w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
									<svg className="w-12 h-12 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="4" y="6" width="16" height="14" rx="2" strokeWidth="2"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" strokeWidth="2"/><line x1="8" y1="12" x2="16" y2="12" strokeWidth="2"/><line x1="8" y1="16" x2="16" y2="16" strokeWidth="2"/></svg>
								</div>
								<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-3 text-center">Calderas</h3>
								<p className="text-gray-600 text-center mb-6">Especialistas en calderas con más de 10 años de experiencia</p>
								<div className="space-y-2">
									<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Mantención</span></div>
									<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Reparación</span></div>
									<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Operación</span></div>
									<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Limpieza de Tubos</span></div>
									<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Pasivado</span></div>
								</div>
							</div>
						</div>
								<div className="service-card bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
									<div className="h-2 bg-orange-primary" />
									<div className="p-8">
										<div className="service-icon-container icon-container w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
											<svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
										</div>
										<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-3 text-center">Certificaciones</h3>
										<p className="text-gray-600 text-center mb-6">Preparación y certificación de calderas y operadores para garantizar seguridad y eficiencia.</p>
										<div className="space-y-2">
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Registro en Seremi</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Preparación y apoyo a operadores de caldera</span></div>
										</div>
									</div>
								</div>
								<div className="service-card bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
									<div className="h-2 bg-orange-primary" />
									<div className="p-8">
										<div className="service-icon-container icon-container w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
											<svg className="w-12 h-12 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M13 10V3L4 14h7v7l9-11h-7z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
										</div>
										<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-3 text-center">Equipos Térmicos</h3>
										<p className="text-gray-600 text-center mb-6">Especialistas en equipos térmicos con amplia experiencia en mantenimiento y reparación.</p>
										<div className="space-y-2">
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Tableros eléctricos</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Bombas</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Quemadores</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Salas de Calderas</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Autoclave</span></div>
										</div>
									</div>
								</div>
								<div className="service-card bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
									<div className="h-2 bg-orange-primary" />
									<div className="p-8">
										<div className="service-icon-container icon-container w-20 h-20 rounded-2xl flex items-center justify-center mb-6 mx-auto">
											<svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
										</div>
										<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-3 text-center">Asesoría</h3>
										<p className="text-gray-600 text-center mb-6">Comunícate con un experto en el rubro que pueda aclarar todas tus dudas</p>
										<div className="space-y-2">
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Online</span></div>
											<div className="flex items-center gap-2 text-sm text-gray-700"><svg className="w-5 h-5 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg><span>Presencial</span></div>
										</div>
									</div>
								</div>
					</div>
				</div>
			</section>

			<section id="socio" className="py-24 bg-gray-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center max-w-3xl mx-auto mb-12"><span className="text-orange-primary font-semibold uppercase tracking-wider text-sm">Alianza Estratégica</span>
						<h2 className="font-heading font-bold text-4xl text-gray-corporate mt-4 mb-6">Socio <span className="text-orange-primary">Clave</span></h2>
						<div className="section-divider mx-auto" />
					</div>
					<div className="bg-white rounded-3xl shadow-xl overflow-hidden">
						<div className="grid lg:grid-cols-2 gap-0">
							<div className="p-12 flex flex-col justify-center">
								<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-6">Repuestos Especializados</h3>
								<p className="text-lg text-gray-600 leading-relaxed mb-8">Contamos con un socio estratégico para la obtención de repuestos específicos de calderas y equipos industriales, garantizando disponibilidad inmediata y calidad certificada para todos nuestros proyectos.</p>
								<div className="flex items-center gap-4">
									<svg className="w-12 h-12 text-orange-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
									<div>
										<p className="font-semibold text-gray-corporate">Repuestos originales y certificados</p>
										<p className="text-sm text-gray-500">Garantía de calidad y durabilidad</p>
									</div>
								</div>
							</div>
							<div className="bg-gradient-to-br from-gray-corporate to-gray-700 p-12 flex items-center justify-center">
								<div className="text-center">
									<div className="logo-socio-container">
										
										<img src="/2vias_v1_gota.png" alt="Dos Vías Logo" className="logo-socio" />
										
									</div>
									<a href="https://dosvias.cl" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-orange-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-all">
										Visitar sitio web
										<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="nosotros" className="py-24 bg-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center max-w-3xl mx-auto mb-16"><span className="text-orange-primary font-semibold uppercase tracking-wider text-sm">Nuestra empresa</span>
						<h2 className="font-heading font-bold text-4xl text-gray-corporate mt-4 mb-6">Quiénes <span className="text-orange-primary">Somos</span></h2>
						<div className="section-divider mx-auto" />
					</div>
					<div className="grid lg:grid-cols-3 gap-8 mb-16">
						<div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow">
							<div className="w-16 h-16 bg-orange-primary/10 rounded-2xl flex items-center justify-center mb-6">
								<svg className="w-8 h-8 text-orange-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg>
							</div>
							<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-4">Nuestra Empresa</h3>
							<p className="text-gray-600 leading-relaxed">KER está constituido por un equipo de profesionales con más de 15 años de experiencia, inspirados en entregar valor con innovación y eficiencia, ofreciendo un servicio excepcional para la industria.</p>
						</div>
						<div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow">
							<div className="w-16 h-16 bg-orange-primary/10 rounded-2xl flex items-center justify-center mb-6">
								<svg className="w-8 h-8 text-orange-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
							</div>
							<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-4">Equipo Técnico</h3>
							<p className="text-gray-600 leading-relaxed">Contamos con un equipo profesional altamente calificado, con amplia experiencia en el sector industrial, comprometido con la seguridad y la productividad de nuestros clientes.</p>
						</div>
						<div className="bg-gray-50 rounded-3xl p-8 hover:shadow-xl transition-shadow">
							<div className="w-16 h-16 bg-orange-primary/10 rounded-2xl flex items-center justify-center mb-6">
								<svg className="w-8 h-8 text-orange-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
							</div>
							<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-4">Nuestra Misión</h3>
							<p className="text-gray-600 leading-relaxed">Proporcionar mantenimiento y soluciones de alta calidad, ayudando a nuestros clientes a mejorar su productividad, creando ventaja competitiva y garantizando seguridad, eficiencia y responsabilidad.</p>
						</div>
					</div>
					<div className="grid grid-cols-2 md:grid-cols-4 gap-6">
						<div className="bg-gradient-to-br from-gray-corporate to-gray-700 rounded-2xl p-6 text-center">
							<div className="text-4xl font-heading font-bold text-orange-primary mb-2">15+</div>
							<div className="text-white text-sm">Años de experiencia</div>
						</div>
						<div className="bg-gradient-to-br from-gray-corporate to-gray-700 rounded-2xl p-6 text-center">
							<div className="text-4xl font-heading font-bold text-orange-primary mb-2">100%+</div>
							<div className="text-white text-sm">Cobertura nacional</div>
						</div>
						<div className="bg-gradient-to-br from-gray-corporate to-gray-700 rounded-2xl p-6 text-center">
							<div className="text-4xl font-heading font-bold text-orange-primary mb-2">24/7</div>
							<div className="text-white text-sm">Soporte Disponible</div>
						</div>
						<div className="bg-gradient-to-br from-gray-corporate to-gray-700 rounded-2xl p-6 text-center">
							<div className="text-4xl font-heading font-bold text-orange-primary mb-2">100%</div>
							<div className="text-white text-sm">Clientes satisfechos</div>
						</div>
					</div>
				</div>
			</section>

			<section id="contacto" className="py-24 bg-gray-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="text-center max-w-3xl mx-auto mb-16"><span className="text-orange-primary font-semibold uppercase tracking-wider text-sm">Hablemos</span>
						<h2 className="font-heading font-bold text-4xl text-gray-corporate mt-4 mb-6"><span className="text-orange-primary">Contáctanos</span></h2>
						<div className="section-divider mx-auto" />
					</div>
					<div className="grid lg:grid-cols-2 gap-12">
						<div className="bg-white rounded-3xl p-8 lg:p-12 shadow-xl">
							<h3 className="font-heading font-bold text-2xl text-gray-corporate mb-6">Solicita una evaluación</h3>
							<form id="contactForm" className="space-y-6" onSubmit={handleSubmit}>
								<div className="grid sm:grid-cols-2 gap-6">
									<div>
										<label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">Nombre</label>
										<input type="text" id="nombre" name="nombre" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-orange-primary focus:ring-2 focus:ring-orange-primary/20 outline-none transition-all" placeholder="Tu nombre" />
									</div>
									<div>
										<label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-2">Empresa</label>
										<input type="text" id="empresa" name="empresa" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-orange-primary focus:ring-2 focus:ring-orange-primary/20 outline-none transition-all" placeholder="Nombre de tu empresa" />
									</div>
								</div>
								<div className="grid sm:grid-cols-2 gap-6">
									<div>
										<label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">Teléfono</label>
										<input type="tel" id="telefono" name="telefono" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-orange-primary focus:ring-2 focus:ring-orange-primary/20 outline-none transition-all" placeholder="+56 9 1234 5678" />
									</div>
									<div>
										<label htmlFor="correo" className="block text-sm font-medium text-gray-700 mb-2">Correo</label>
										<input type="email" id="correo" name="correo" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-orange-primary focus:ring-2 focus:ring-orange-primary/20 outline-none transition-all" placeholder="tu@email.com" />
									</div>
								</div>
								<div>
									<label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-2">Mensaje</label>
									<textarea id="mensaje" name="mensaje" rows="4" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-orange-primary focus:ring-2 focus:ring-orange-primary/20 outline-none transition-all resize-none" placeholder="Cuéntanos sobre tu proyecto o necesidad..."></textarea>
								</div>
								<button type="submit" id="submitBtn" className="w-full btn-primary text-white px-8 py-4 rounded-xl font-bold text-lg flex items-center justify-center gap-2" disabled={formLoading}>
									{formLoading ? (
										<>
											<svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
												<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
												<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
											<span>Enviando...</span>
										</>
									) : (
										<>
											<span>Enviar solicitud</span>
											<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
										</>
									)}
								</button>
								<div
									id="formMessage"
									className={`${formMessage ? `text-center p-4 rounded-xl ${formMessage.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}` : 'hidden text-center p-4 rounded-xl'}`}
								>
									{formMessage ? (
										formMessage.type === 'success' ? (
											<div className="flex items-center justify-center gap-2">
												<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/></svg>
												<span>{formMessage.text}</span>
											</div>
										) : (
											<span>{formMessage.text}</span>
										)
									) : null}
								</div>
							</form>
						</div>

						<div className="space-y-8">
							<div className="bg-gradient-to-br from-gray-corporate to-gray-700 rounded-3xl p-8 text-white shadow-xl">
								<h3 className="font-heading font-bold text-2xl mb-6">Información de contacto</h3>
								<div className="space-y-6">
									<div className="flex items-start gap-4">
										<div className="w-12 h-12 bg-orange-primary rounded-xl flex items-center justify-center flex-shrink-0">
											<svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
										</div>
										<div>
											<h4 className="font-semibold mb-1">Teléfonos</h4>
											<p id="phonePrimary" className="text-gray-300">+56 9 7389 1406</p>
											<p id="phoneSecondary" className="text-gray-300">+56 9 3080 7076</p>
										</div>
									</div>
									<div className="flex items-start gap-4">
										<div className="w-12 h-12 bg-orange-primary rounded-xl flex items-center justify-center flex-shrink-0">
											<svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
										</div>
										<div>
											<h4 className="font-semibold mb-1">Correos</h4>
											<p id="emailPrimary" className="text-gray-300">contacto@ker.cl</p>
											<p className="text-gray-300">karina@ker.cl</p>
										</div>
									</div>
									<div className="flex items-start gap-4">
										<div className="w-12 h-12 bg-orange-primary rounded-xl flex items-center justify-center flex-shrink-0">
											<svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
										</div>
										<div>
											<h4 className="font-semibold mb-1">Ubicaciones</h4>
											<p className="text-gray-300">Santiago – Antofagasta</p>
										</div>
									</div>
								</div>
							</div>

							<div className="bg-gray-100 rounded-3xl overflow-hidden h-64 relative shadow-xl">
								<div className="absolute inset-0 flex items-center justify-center">
									<div className="text-center">
										<div className="w-16 h-16 bg-orange-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
											<svg className="w-8 h-8 text-orange-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
										</div>
										<p className="text-gray-600 font-medium">Santiago – Antofagasta</p>
										<p className="text-gray-500 text-sm">Cobertura nacional</p>
									</div>
								</div>
								<svg className="absolute inset-0 w-full h-full opacity-10" viewBox="0 0 400 300">
									<defs>
										<pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
											<path d="M 40 0 L 0 0 0 40" fill="none" stroke="#535353" strokeWidth="1" />
										</pattern>
									</defs>
									<rect width="100%" height="100%" fill="url(#grid)" />
								</svg>
							</div>
						</div>
					</div>
				</div>
			</section>

			<footer className="bg-gray-900 py-16">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="grid md:grid-cols-4 gap-12 mb-12">
						<div className="md:col-span-2">
							<div className="flex items-center gap-3 mb-6">
								<img src="/logo512.png" alt="KER Logo footer" className="footer-logo-icon" />
								
							</div>
							<p className="text-gray-400 max-w-md">Más de 15 años entregando soluciones integrales para la continuidad operativa de la industria chilena.</p>
						</div>
						<div>
							<h4 className="font-heading font-bold text-white mb-4">Servicios</h4>
							<ul className="space-y-3 text-gray-400">
								<li><a href="#servicios" className="hover:text-orange-primary transition-colors text-gray-400">Calderas</a></li>
								<li><a href="#servicios" className="hover:text-orange-primary transition-colors text-gray-400">Certificaciones</a></li>
								<li><a href="#servicios" className="hover:text-orange-primary transition-colors text-gray-400">Equipos Térmicos</a></li>
								<li><a href="#servicios" className="hover:text-orange-primary transition-colors text-gray-400">Asesoría</a></li>
							</ul>
						</div>
						<div>
							<h4 className="font-heading font-bold text-white mb-4">Contacto</h4>
							<ul className="space-y-3 text-gray-400">
								<li>+56 9 7389 1406</li>
								<li>contacto@ker.cl</li>
								<li>Santiago – Antofagasta</li>
							</ul>
						</div>
					</div>
								<div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
									<p className="text-gray-500 text-sm">© 2026 KER Mantenimiento Industrial. Todos los derechos reservados.</p>
						<div className="flex items-center gap-4"><span className="text-gray-500 text-sm">Hecho con</span> <span className="text-orange-primary">❤</span> <span className="text-gray-500 text-sm">en Chile</span></div>
					</div>
				</div>
			</footer>
		</div>
	);
}

